import api from './client';

export interface Category {
  id: string;
  name: string;
  description: string | null;
  difficulty: number;  // 1=Easy, 2=Medium, 3=Hard
  time_limit_seconds: number;
  card_count: number;
  level: number;  // Position in progression (1, 2, 3...)
  is_unlocked: boolean;
  perfect_count: number;  // 0-10
  required_perfect_count: number;  // 5
  is_mastered: boolean;  // True if 10+ perfect scores (permanently locked)
  mastery_threshold: number;  // 10
}

export interface Card {
  question: string;
  options: string[];
  difficulty: number;
}

export interface GameSession {
  session_id: string;
  category: { name: string; time_limit_seconds: number };
  total_cards: number;
  current_card: number;
  card: Card;
}

export interface GameSummary {
  total_questions: number;
  correct_answers: number;
  xp_earned: number;
  coins_earned: number;
  character_new_xp: number;
  character_level: number;
  character_id: string;
  pending_level_up: number | null;
  was_perfect: boolean;
  unlocked_category_name: string | null;
  mastery_achieved: boolean;  // True if this was the 10th perfect score
  mastery_bonus: number;  // Bonus coins/XP awarded for mastery
}

export interface AnswerResult {
  correct: boolean;
  correct_answer: string;
  xp_earned: number;
  coins_earned: number;
  current_card: number;
  next_card: Card | null;
  session_complete: boolean;
  summary: GameSummary | null;
}

export const listCategories = async (): Promise<Category[]> => {
  const res = await api.get('/api/categories');
  return res.data;
};

export const startGame = async (category_id: string): Promise<GameSession> => {
  const res = await api.post('/api/game/start', { category_id });
  return res.data;
};

export const submitAnswer = async (session_id: string, answer: string): Promise<AnswerResult> => {
  const res = await api.post('/api/game/answer', { session_id, answer });
  return res.data;
};

export const endGameEarly = async (session_id: string): Promise<{ session_complete: boolean; summary: GameSummary }> => {
  const res = await api.post('/api/game/end', { session_id });
  return res.data;
};
